import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
          准备好开始你的
          <span className="font-heading italic text-primary-500">韩漫之旅</span>了吗？
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          数以千计的韩国漫画正在等你发现，立即加入我们，开启精彩阅读体验
        </p>
        <div className="mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
          >
            立即免费阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="mt-12">
          <img
            src="https://readdy.ai/api/search-image?query=A%20horizontal%20manga%20style%20illustration%20banner%2C%20colorful%20Korean%20webtoon%20characters%20in%20various%20dynamic%20poses%20arranged%20in%20a%20row%2C%20clean%20white%20background%2C%20cutout%20style%2C%20vibrant%20colors%2C%20Korean%20manhwa%20art%20style%2C%20cheerful%20and%20energetic%20mood&width=1200&height=400&seq=cta-comic-strip&orientation=landscape"
            alt="韩漫画网漫画角色"
            title="韩漫画网 - 立即开始阅读"
            className="w-full rounded-xl object-cover"
            loading="lazy"
            style={{ maxHeight: '300px' }}
          />
        </div>
      </div>
    </section>
  );
}